import { LoadingOutlined } from "@ant-design/icons";

export const CustomLoader = () => <LoadingOutlined style={{ fontSize: 32, color: "#4096ff" }} spin />